module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('strong', [_vm._v("1"), _c('br'), _vm._v("Punishing Intent, Harm, or Dangerousness?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("WHAT SHOULD THE criminal law focus on when it assigns punishment? A person’s mental state? (What was the person’s purpose? Were the conduct and its consequences intentional or accidental?) Whether there was actual harm? (Did the harm or evil defined by the offense actually occur, or did the person just intend or risk it?) Whether the person is dangerous? (Was this offense an aberration of character, or, if released, will the person commit another offense?) Are all these factors—intent, harm, and dangerousness—relevant? If so, how and when? What effect should they have? And how do they relate to one another?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The three cases that follow ask you for your answer to these questions, and sketch the law’s answers. They also reveal some serious inconsistencies in the law’s response, serious enough to suggest that what is needed is a rethinking of the nature and goals of modern criminal law.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev1sec1"
    }
  }, [_c('strong', [_vm._v("ARE EVIL INTENTIONS A CRIME?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On a night in late October 1993, Sergeant Ian Grimes is patrolling in an unmarked car in Glendale, a suburb northwest of Los Angeles. A Thunderbird squeals its tires as it pulls out of a gas station and speeds north on Pacific Avenue toward the Ventura Freeway. Grimes gives chase and pulls the car over, for speeding, before it reaches the freeway on-ramp. He approaches the passenger side and talks to the driver through the passenger window. The driver gives the name “Dennis Franks,” but has no license, claiming he left it at home. In response to Grimes’s questioning, the driver seems confused about his home address. The passenger explains that the car belongs to the driver’s mother, but Grimes has already learned over his radio that it is a rental car from the airport. He directs the driver to step out and stand at the right rear of the car, where he can see both men as he talks further to them. Both are big. The driver is six feet, 210 pounds; the passenger, six feet, 340 pounds.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0004-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Left :")]), _vm._v(" Larry Eugene Phillips. (Archive Photos)")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0004-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Right:")]), _vm._v(" Emil Matasareanu. (Archive Photos)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The driver stands in an odd way as he talks, holding his body at an angle. He claims not to be armed, but Grimes realizes the man’s odd stance is to make his shirt hang over and hide a nine-millimeter Glock 17 in his waistband. Grimes takes the weapon and backs up, taking cover behind a nearby planter on the sidewalk. The driver won’t respond to Grimes’s commands, nor for a moment will the passenger. Finally, Grimes hears a “clonk,” which turns out to be the passenger dropping a Glock that he was holding. The passenger puts his hands out the window and Grimes holds the two in that position until backup arrives.")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_vm._v("A search of the car reveals the following:")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• one Norinco folding stock, semiautomatic rifle")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• one MAK 90 wood-stock, semiautomatic rifle")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• one Springfield Armory .45 pistol")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• one Colt .45 pistol")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• 1,649 rounds of 7.62 x 39 mm ammo, most loaded into 40-round magazines, taped three-together")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("• three seventy-five-round drum magazines loaded with 7.62 x 39 mm ammo")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• 967 rounds of 9 x 19 mm JHP ammo")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• 357 rounds of .45 JHP ammo")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• six smoke bombs")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• two improvised explosive devices")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• one gas mask")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• two sets of National Body Armor Level III-A vests")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• two 200-channel, portable, programmable scanners with ear-pieces")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• sunglasses, gloves, wigs, ski masks, stopwatch")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• two spray cans of gray Studio Hair Color")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• three different California automobile license plates")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_vm._v("• $1,620 cash")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The driver initially refuses to answer questions, but is subsequently identified as twenty-three-year-old Larry Eugene Phillips. The passenger is twenty-seven-year-old Emil Dechebal Matasareanu.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the station, the men explain their load of weapons by telling police they are on their way to a shooting range in the Angeles National Forest known as “Kentucky.” It is just before Halloween, “Devil’s Night.” The disguises and other material may be needed for a Halloween party after the shooting range.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0005-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Top")]), _vm._v(" The Glendale Police Department and bomb squad investigate the red Ford Thunderbird. (Gene Blevins, "), _c('em', [_vm._v("Los Angeles Daily News")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0006-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Top")]), _vm._v(" Two semiautomatic assault rifles found in the trunk of the red Ford Thunderbird that Larry Phillips was driving. (Gene Blevins, "), _c('em', [_vm._v("Los Angeles Daily News")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0006-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Bottom:")]), _vm._v(" 200-channel programmable police scanners and gloves found by Sergeant Ian Grimes and the Glendale Police Department. (Gene Blevins, "), _c('em', [_vm._v("Los Angeles Daily News")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0007-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Evidence room at the Glendale Police Department where the contents of the red Ford Thunderbird were laid out. (Gene Blevins, "), _c('em', [_vm._v("Los Angeles Daily News")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The police, and later the prosecutors, have little doubt the police have stumbled onto two robbers on their way to a job. The arsenal and supplies are a classic “bank robbery kit.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The two men are probably liable for at least some weapons offenses. (Their assault rifles are not at the time illegal in California.) Should the two also be held criminally liable for attempted robbery? If so, what amount of punishment would you impose for attempted robbery?"), _c('br'), _c('br')]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "60%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("no liability")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("liability but no punishment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 day")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 weeks")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("6 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 year")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("7 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("15 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("30 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("life imprisonment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("death")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  }), _c('br'), _c('br')])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("(In answering this and similar liability questions throughout the book, if you would impose a punishment other than imprisonment—a fine or community service—translate that sentence into a term of imprisonment of equivalent punitive bite, in order to allow easier comparison of assigned punishments.)")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec1"
    }
  }, [_c('strong', [_vm._v("People’s Intuitions of Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Few people are likely to believe Phillips’s story that the two are on their way to a shooting range and then a Halloween party. Homemade explosives? Police scanners? Stopwatch and gloves? It doesn’t fit. And unless they are going to be shooting at each other at the party, why bulletproof vests? Clearly these folks are up to something bad. That the items together make what the experts call a “bank robbery kit” only confirms the suspicion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the same time, most people faced with these facts seem hesitant to hold Phillips liable for attempted robbery or conspiracy to rob. Rob what? Where? When? We know nothing about what the two specifically intend. Another concern is how real the intention is. Even if the two had a plan, would they really have done it, or is this a Walter Mitty pair who has watched too many television shows? Was their intention sufficiently formed and resolute that they really would have gone ahead with a robbery if they had gotten to a bank or whatever their target was?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even if the "), _c('em', [_vm._v("intent")]), _vm._v(" to rob was clear, people typically have a sense that a person must do enough toward committing the offense for it to count as a crime. Bad intention may be enough for sin, in a religious sense, but criminal liability requires sufficient "), _c('em', [_vm._v("conduct")]), _vm._v(" toward the offense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In one Mississippi case, a burglar was caught with a list in his pocket of items needed for the burglary, in an envelope conveniently labeled “Preparations for a Burglary.” Assume Phillips had such a “Preparations for a Robbery” envelope, so his intention was clear. Would it make this case clear, or would we still have some concern that these two would-be robbers still have not done enough to make a crime? They have raised strong suspicion, but has it matured into proof of a crime?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Several hundred people have been given the facts of this case (and all the cases in this book) and been asked to sentence the defendant using the same scale that you were given above. Here is how the people in the survey sentenced Phillips:"), _c('br'), _c('br')]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "85%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("no liability")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("59%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("liability but no punishment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 day")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 weeks")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("6 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 year")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("7%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("19%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("7 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("4%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("15 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("4%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("30 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("life imprisonment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("death")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Mean = 2.4 weeks."), _c('br'), _c('br')])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even on such suspicious facts, 59 percent of the people would not impose liability for attempted robbery.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec2"
    }
  }, [_c('strong', [_vm._v("The Law’s Rules")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The intuitions of this majority match the law’s high requirements. The law requires proof of both an intention to commit the offense beyond a reasonable doubt and sufficient conduct toward commission of the offense. The facts of this case—carrying a robbery kit and giving a doubtful explanation—do not present a strong case for attempt liability.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jurisdictions disagree as to how much conduct is enough. Some require that the person be in “dangerous proximity” of committing the offense—that he present an imminent threat. Others require only that the person has taken a “substantial step” toward its commission. Most of the legal requirements for minimum conduct are vague, like these two. Thus, when juries are given legal instructions, they probably just express their own intuitive sense of how much is enough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why such intention and minimum conduct requirements for criminal liability? Our intuitive notions of justice typically don’t see thinking bad thoughts, or even acting on them in a preliminary way, as sufficient to be criminal. Most people seem to feel that punishment is deserved only when, first, the intention is sufficiently developed and firm and, second, the person has come sufficiently close to committing the offense.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec3"
    }
  }, [_c('strong', [_vm._v("Background")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry Eugene Phillips, born on September 9, 1970, gets his first exposure to the life of crime on his sixth birthday, when the FBI knocks on "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("the door of the family home in Denver. Before Larry’s eyes, they arrest his father, Larry, Sr., who has been a fugitive from a Colorado prison since his son’s birth. A few years later Larry’s mother, Dorothy Clay, finalizes a divorce and moves with her son to a suburb of Los Angeles. His mother is no stranger to crime, once serving ten years for drug possession and stabbing a prison guard. At the age of nineteen, Phillips gets arrested for the first time after stealing four hundred dollars from a Sears store in Alhambra, California.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Phillips and Emil Dechebal Matasareanu meet in 1989 and quickly become friends. They both enjoy weapons and like to go shooting together. Although four years the younger, Phillips, controlling and manipulative, becomes the duo’s leader. “You can’t imagine how manipulative my brother was,” explains Phillips’s half-brother later. “He tried to break your mind down and then build it up again so that you would become one of his crew.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Phillips, a clean-shaven bodybuilder, dreams incessantly of wealth, fantasizing about spending one hundred-dollar bills by the handful. He idolizes the 1980s robber baron Michael Milken and the movie-screen legend the “Godfather.” To pass the time, he sometimes drives around the chic neighborhoods of Los Angeles, watching the celebrities come and go, and pictures himself living their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Matasareanu, born in Romania on July 19, 1966, moves to California as a child and grows up in Altadena, a suburb fifteen miles northeast of downtown Los Angeles, and other areas. Matasareanu’s mother, a former singer who defected from the Romanian state opera, describes her son as a very intelligent boy. She struggles to raise him on her own. As a chubby boy, he is the butt of teasing from other children and classmates. The isolation of his youth turns him early to computers as an outlet. He gets formal computer training at the DeVry Institute.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his twenties, Matasareanu returns to Romania, marries, moves back to the United States, has a son, and starts a computer business. Not long after his marriage, a blocked artery in his brain causes him to begin suffering epileptic seizures that require surgery. Soon after, his computer business fails.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1990 the twenty-year-old Phillips takes the California real estate examination and passes. However, officials in the Department of Real Estate discover his 1989 theft conviction through a routine fingerprint check, and the state turns him down for a license because his application failed to disclose the conviction. About that time, Phillips, with no "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("license, tells his probation officer that he is making a lot of money, about two thousand to four thousand dollars per transaction, as a real estate agent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1991 Phillips, now twenty-one, is arrested again, this time in Orange, California, on weapons charges, when a police officer spots a semiautomatic nine-millimeter pistol in his waistband and an extra clip of ammunition and a knife hidden inside a compartment in his BMW. He insists he needs the gun for protection because he is going to pick up a large amount of cash from a real estate transaction. Detectives in the Orange Police Department, while investigating the weapons charges, link him to a real estate scam involving forged title documents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Phillips also goes by the names Larry Franks, Dennis Franks, and Denis Rene. He regularly changes his address within the same city and gives false addresses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1992 Denver police link Phillips to a residential burglary and arrest him. He pleads guilty but skips the sentencing hearing and returns to California. Denver police also link Phillips and Matasareanu to the robbery of an armored car, but by the time they have gathered enough evidence to arrest the pair, they have gone back to California.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout the early 1990s, police and repossession agents search diligently but unsuccessfully for Phillips, repeatedly checking for him at a house he once rented in Altadena. In 1993 Phillips, going by the name Larry Martinez, marries a woman he met while in Denver, Janette Teresa Federico, who is the mother of a young girl by another man. After the two move back to Los Angeles, they split up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then comes the bad luck traffic stop in Glendale.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec4"
    }
  }, [_c('strong', [_vm._v("The Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That Phillips has a criminal history at the time of the traffic stop in Glendale only confirms our suspicions about his intentions. But that history does not alter the fact that, when stopped, he had not yet done much toward commission of a specific robbery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Deputy District Attorney James Grodin initially charges Phillips and Matasareanu with conspiracy to commit robbery and holds them on bond as prosecutors figure out what to do. Grodin sees real problems with the prosecution because they have no evidence of a criminal agreement between the two to rob, which conspiracy to rob requires, and little evidence of a specific robbery planned, thus no grounds for "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("attempted robbery. Says Grodin, “We didn’t have a lot. I didn’t know what the men were doing.… I wanted to charge him with whatever I could. We actually sat around thinking what we could do.… We didn’t have a lot of proof.… These assault weapons were not the AK-47s.… They were copycats that you could have legally at the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Phillips pleads no contest to one felony and one misdemeanor weapons charge and serves ninety-nine days in jail. Matasareanu serves seventy-one days. Both are placed on probation for three years, but rarely see their probation officer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Defense attorneys request the return of the seized weapons and property, and a judge grants most of the request. After their release, the two reclaim their bulletproof vests, hollow-point bullets, the two .45-caliber pistols, the MAK-90 rifle, police scanners, gas mask, wigs, fake mustaches, stopwatch, gloves, clothes, and sunglasses. Some material is returned with a specific requirement that it be sold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Free again, Phillips reenters the real estate scam business, but with little apparent success. In 1995 he and two other men are ordered to pay $140,000 in principal and interest to reimburse a mortgage title company for forged deeds. During part of this time, he moves back in with his mother and a girlfriend, April Coleman, along with the couple’s illegitimate son. Less than a year later, Coleman moves out and obtains a court order for $152 monthly child support.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unfazed by their 1993 arrest, Phillips and Matasareanu return to high-stakes robberies. In 1995 they rob an armored car and kill the guard, then attempt to rob another armored car. In May 1996 Phillips and Matasareanu rob two Bank of America branches in San Fernando Valley near Los Angeles. They enter the bank dressed in combat fatigues, fire shots into the ceiling and vault to scare the customers, and order everyone to the floor. The robberies seem amazingly well timed and come just after the banks have received large shipments of cash. Police and the FBI begin investigating whether the unknown robbers have ties to organized crime groups or paramilitary organizations. “It’s obvious these guys did their homework,” one investigator says. The robbers net about $1.5 million. The two begin living the high life, wearing $500 suits, $200 shoes, and Rolex watches, and driving BMWs, Jaguars, and Lincolns.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In August 1996 Matasareanu’s wife, Christina, leaves him, taking their two- and five-year-old sons with her. At the same time, state investigators begin closing in on him and his mother for the abuse and "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("neglect of patients at her day care center for elderly and disabled people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On February 28, 1997, Phillips and Matasareanu start to assemble gear for what they hope will be their biggest heist yet: another Bank of America branch, this one in North Hollywood on Laurel Canyon Road. They hide a getaway car—a gray, late-model sedan—in a Mission Hills neighborhood, and plant two mayonnaise jars filled with gasoline in the trunk for use in later blowing up the car to cover their tracks. They also stock the car with a hundred-round drum of high-powered ammunition. They steady their nerves with doses of phenobarbital.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At 9:17 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")]), _vm._v(", a few minutes after the bank opens, the two men burst in carrying fully automatic AK-47 assault rifles, spraying bullets indiscriminately. Screaming customers dive for the floor. Some are herded into the safe deposit box area.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When they find only $304,000 in the vault, the men fly into a rage. (Since Phillips’s May 1996 robberies and similar ones at Bank of America branches around Los Angeles, the bank has begun keeping less cash at each of its locations.) Phillips and Matasareanu viciously beat one branch official because he cannot produce more money. The brief indulgence throws off their military timing as they ignore the stopwatches sewn to their gloves. Witnesses call police, who are already responding to a silent alarm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The police soon close in on the bank and call for reinforcements, aware that recent Southern California bank robbers have been heavily armed. News helicopters hover above, broadcasting the scene live across the country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the two men emerge from the bank, they are met by a police blockade. But Phillips and Matasareanu are ready. The pair are wearing Kevlar body armor, which is almost impenetrable to ordinary bullets. In the fusillade that follows, bullets bounce off the two as if they are supermen. They spray the crowd of bystanders and police with hundreds of rounds, tearing up trees, signs, mailboxes, and windows. The SWAT team arrives but realizes that it too is outgunned. They visit a local gun shop to get additional armaments. The shoot-out goes on for twenty minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two men try to escape east on Archwood Street. Phillips, on foot, has his escape route cut off, but continues to shoot at anything that moves. At 9:52 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")]), _vm._v(" on Archwood, less than a block from the bank, he shoots himself in the head with his nine-milimeter semiautomatic "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v(" pistol. Simultaneously, a police sharpshooter’s bullet slams into his neck, severing his spinal cord.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Surveillance photos from Bank of America of robbery in progress. (the FBI)")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0015-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("One of the gunmen as he shoots at Los Angeles police officers in front of Bank of America. (Gene Blevins, "), _c('em', [_vm._v("Los Angeles Daily News")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("LAPD officers and SWAT team, as they use an armored car to rescue a man who was shot six times during the shoot-out. (Gene Blevins, "), _c('em', [_vm._v("Los Angeles Daily News")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("Matasareanu drives east in the getaway car, a white Chevrolet sedan. Police shoot out two of the car’s tires. Four blocks down Arch-wood, Matasareanu tries to commandeer a Jeep pickup truck. He lets go a burst of gunfire with his AK-47 through his own windshield into the Jeep. Its driver, fifty-two-year-old William Marr of Burbank, is struck by flying glass and shrapnel. He jumps from his truck and flees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Matasareanu tries to start Marr’s Jeep, a black and white squad car, loaded with SWAT officers, approaches at high speed and pulls in front of the two stopped cars. Matasareanu gets out of the Jeep and crouches behind his Chevy as the officers open fire, now at close range.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For two minutes, the police and Matasareanu blast away at each other, just a car length apart. Matasareanu is shot twenty-nine times, and surrenders. Officers handcuff him at 9:59 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")]), _vm._v(" and call ambulances for the gunman and his last victim, Marr.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Afraid that the two robbers have rigged bombs to themselves or might have nearby accomplices, police refuse to let paramedics touch either body for several minutes. In that time, Matasareanu bleeds to death. “His actions were more like a suicide,” says Matasareanu’s mother, Valerie Nicolescue. (But she later sues the police department for wrongful death for letting her son bleed to death.)")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An LAPD officer prays while taking cover behind a squad car as gunmen fire. (Gene Blevins, "), _c('em', [_vm._v("Los Angeles Daily News")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0018-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("LAPD officers survey the dead robber. (Gene Blevins, "), _c('em', [_vm._v("Los Angeles Daily News")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eleven police officers and five civilians are wounded in the shoot-out. In the trunk of the men’s bullet-ridden car, police find two mayonnaise jars filled with gasoline, each rigged with triggers to ignite the bombs and destroy the car after the planned getaway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Police clad in flak jackets search Phillips’s Altadena house after the shoot-out. A search of Matasareanu’s rented sprawling, multilevel Rowland Heights home turns up two high-powered rifles, a pistol-grip shotgun, two bulletproof vests, police T-shirts, patches with police insignia, and paramilitary and survivalist literature. In the trunk of Matasareanu’s Buick Century, parked in the garage, they find a Tupperware bowl containing plastic explosive with wires attached.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the days following the shoot-out—the largest in California history—news reports show the gun battle over and over.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the earlier arrest of the two men comes to light, there is much hand wringing. Clearly, if the requirements for attempt liability were less demanding—if a highly suspicious intention were sufficient, for example—Phillips and Matasareanu would have been convicted of attempted robbery and would still be in prison. The North Hollywood "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("shoot-out never would have occurred. Despite this obvious cost of the more demanding requirements for attempt and despite the televised spectacle of a morning of automatic weapons fire in North Hollywood, there is no suggestion that the minimum requirements for criminal attempt be weakened. The excesses of the "), _c('em', [_vm._v("Phillips")]), _vm._v(" case only confirm the depth of commitment to the present liability requirements of a sufficiently developed and resolute intent and sufficiently advanced conduct.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec5"
    }
  }, [_c('strong', [_vm._v("Attempt versus the Complete Offense: The Significance of Resulting Harm")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Assume for the sake of argument that Phillips and friend in fact had gone further. Assume they were stopped by police in front of a bank. If that is not enough to make attempted robbery liability clear for you, assume further they are caught just as they are pulling ski masks down over their faces while sitting in front of the bank. Presumably, on these facts, their intention is sufficiently mature and their conduct sufficiently advanced for liability for attempted bank robbery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Should their liability in such a case of attempted bank robbery be the same as it would be for bank robbery itself—that is, the same as if they in fact had entered the bank, displayed their weapons, taken the money, and fled? A few people, and many academics, will say yes, the liability for attempted robbery ought to be the same as for actual robbery. That the police got lucky, or smart, in the interrupted-attempt case does not reduce the subjective culpability of the culprits. In fact, even the American Law Institute’s Model Penal Code, which has been the blueprint in varying degrees for over two-thirds of the criminal codes in the United States, provides, generally, that attempts are to be graded the same as the offense attempted. Under that code, the outside-the-bank interrupted-attempted robbery would be as serious an offense as the took-the-money-and-ran robbery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But this provision in the Model Penal Code is one of the most frequently rejected by state legislatures that use the code as a model. The intuition that the occurrence of resulting harm does matter is nearly universal and runs very deep among the public. Most jurisdictions grade the completed offense as more serious than the attempt, usually carrying double the statutory penalty of attempt. The next case explores our intuitions about, and the law’s treatment of, resulting harm.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev1sec2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('strong', [_vm._v("CAN FATHER AND DAUGHTER KILL THE SAME MAN TWICE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is 1874. Joseph B. Wood’s daughter, Alma, a short, slight woman in her late twenties, marries Luman Smith, a farmer in Williston, Vermont. It is Alma’s second marriage. She brings to it a child from her previous marriage, Joseph B. (named after his grandfather). Luman, forty, and Alma have two children together. Luman is devoted to the children.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The relationship between Luman and Alma is not good and they have many fights. Alma leaves the home several times between 1874 and 1879. Tensions in the household are heightened by Alma’s infidelity and prostitution, and by Luman’s threats and sometimes violence toward Alma. In 1879 Alma again leaves Luman, the farm, and the three children.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Luman soon realizes he cannot run a farm and raise the three children by himself. The infant, in particular, requires constant attention. He goes to his estranged wife and begs her to return. She agrees, but only after he accepts several conditions. First, she is to be given her own room in the house where she can entertain guests without interruption from Luman. Second, her father is to move in with them. This arrangement helps her father and provides her with some degree of protection, if needed, as does the small revolver she has recently purchased. Finally, Luman signs most of his property over to her and agrees to allow her to use his horse when he does not need it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the deal is made and the property transferred, Alma nonetheless begins to plan to move west to Lincoln, Nebraska. Luman carries a good-sized dirk knife (a short, straight dagger) with him throughout the day. Fearing that Luman might use it against her, Alma steals the knife and hides it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On October 23, just a few days after Alma and her father move back to the farm, Luman returns from a visit to the doctor in Essex Junction. His daughter Helen runs to greet him at the gate and they walk to the stable so Luman can hitch up his horse to go into town.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Joseph Wood enters the stable and objects to Luman hitching the horse, telling Luman he can no longer use it. Luman explains that the horse was not transferred to Alma with the other property, but Wood is undeterred. Before Luman can finish hitching the horse, Wood pulls a pistol on Luman, who grabs the barrel and points it away. The two men struggle. Wood fires several shots at Luman but misses. Finally, Wood points the gun at Luman’s abdomen and pulls the trigger. It is a lethal wound.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A typical 1880s Vermont farm. (Vermont Historical Society)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("Would you convict Wood for the killing of Luman? If so, what amount of punishment would you impose?"), _c('br'), _c('br')]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "85%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("no liability")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("liability but no punishment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 day")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 weeks")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("6 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 year")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("7 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("15 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("30 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("life imprisonment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("death")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  }), _c('br'), _c('br')])])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec6"
    }
  }, [_c('strong', [_vm._v("People’s Intuitions of Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is an intentional killing, murder. Most people would punish severely, although some people would view the case as less egregious than the most serious kind of murder perhaps because it is not a planned killing. Instead, it arises from the “heat of passion” of a fight. "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("And while Wood has no right to use force against Luman, he may mistakenly believe that he does.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Here is how the people in the survey would sentence Wood on these facts:"), _c('br'), _c('br')]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "85%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("no liability")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("liability but no punishment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 day")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 weeks")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("6 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 year")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("4%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("7 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("7%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("15 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("14%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("30 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("22%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("life imprisonment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("41%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("death")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("11%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Mean = between 30 years and life imprisonment."), _c('br'), _c('br')])])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec7"
    }
  }, [_c('strong', [_vm._v("More Facts")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In fact, Luman does not die immediately. The nature of the wound allows him to survive for some time and, for a period, with full mobility. Given the state of medical science at the time, however, all experts agree that he will die from the wound within a week or two due to loss of blood and infection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alma, hearing the gunshots, runs out of the house with her revolver hidden in her apron. As she approaches, Luman sees the gun and grabs for it, but Alma holds tight. Luman begins choking Alma. Afraid for her life, she points the revolver at Luman and fires a round into his chest. Luman staggers away. “You need not shoot again, for I am a dead man.” As Luman slumps, Alma and Wood go back to what they were doing before the shooting, showing no concern or remorse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Luman and the daughter, Helen, make it to the home of Mr. and Mrs. Josiah Thompson, a neighboring farmer. Two doctors are called. Luman’s lungs begin to fill with fluid immediately from Alma’s gunshot wound to his chest. He dies two days later from asphyxiation from the fluid. Experts agree that the would have died from Wood’s shot to the abdomen, had he not first died from Alma’s shot to the chest.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Would you impose criminal liability on Wood? If so, how much liability would you impose?"), _c('br'), _c('br')]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "85%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("no liability")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("liability but no punishment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 day")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 weeks")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("6 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 year")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("7 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("15 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("30 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("life imprisonment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("death")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  }), _c('br'), _c('br')])])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec8"
    }
  }, [_c('strong', [_vm._v("People’s Intuitions of Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If Alma had not come along, Luman would have died from Wood’s shot within a week or two, and Wood would have been liable for Luman’s murder. That Alma has independently killed Luman changes nothing of Wood’s conduct and intention in the case. If Wood’s conduct and intention are all that matter in assessing criminal liability, then nothing is different by virtue of Alma’s killing. Should Wood’s liability and punishment be any less because of events occurring after his conduct—Alma’s killing of Luman—over which he had no control?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most people think causing the harm does matter. The person who shoots and misses because the victim happens to bend down to tie his shoe is seen as deserving less punishment than the person who shoots and kills. Both may have engaged in the same conduct with the same state of mind, but only the latter is a murderer. Wood’s case is different from this only in that the intended victim is in fact dead, but the victim was killed by another person, with no causal connection to Wood or Wood’s wounding.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Here is how the people in the survey sentenced Wood when they knew the whole story:"), _c('br'), _c('br')]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "85%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("no liability")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("liability but no punishment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 day")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 weeks")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("6 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 year")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("4%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("4%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("7 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("17%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("15 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("23%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("30 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("22%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("life imprisonment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("23%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("death")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Mean = 22.5 years."), _c('br'), _c('br')])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("If you compare this distribution of sentences to the previous one (in which Wood was thought to have caused the death), it seems that the entire distribution has shifted about one category to the left. The reduction in the mean from the first variation to the second confirms this. (The points on the penalty scale represent the typical pattern of offense grading categories in American criminal codes. A one-grade reduction, which is what we see here, typically represents a halving of the statutory penalty.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We know Wood’s intention is to shoot Luman, and that he has no justification for doing so. We know he is willing to carry through with this intention. In fact, he did. He went all the way. Indeed, he did in fact cause a lethal wound. That Luman died from Alma’s shot before he could die from Wood’s hardly alters Wood’s subjective culpability. What could all these people be thinking who gave Wood a grade lower sentence?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The answer, of course, is that, however evil Wood’s intention and however much he tried to cause Luman’s death, the fact is he did not cause Luman’s death. And "), _c('em', [_vm._v("causing")]), _vm._v(" harm is of great significance to most people in assessing blameworthiness and criminal liability.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That importance is confirmed by social science studies of the issue. One study used a jewelry store robbery as a base scenario, altering the facts to determine the effect on liability imposed by average people. The perpetrator who completes the jewelry store robbery is given an average sentence of 3.4 years. Where the same robbery is attempted but not completed, the perpetrator’s sentence drops (to between 7.5 days and 1.8 years, depending on how close the robber comes to completion). Another study, using a murder scenario, found life imprisonment as the average sentence for a standard intentional killing, compared to only 9.4 years where the intended victim happened to move, causing the shooter to miss his target. In other words, the failure to actually bring about the harm or evil of the offense results in a significant “discount” off the punishment assigned for the completed offense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a study that used a scenario analogous to the situation in the "), _c('em', [_vm._v("Wood")]), _vm._v(" case, researchers found the no-causation “discount” to be less than usual, for the "), _c('em', [_vm._v("Wood")]), _vm._v(" case presents the most extreme case of attempt that is possible. Not only is the offender’s conduct complete, but he in fact is successful at causing a lethal wound, and in fact the victim dies. The case presents the most technical of differences from the straight murder case, but that minor difference—that Wood’s shot was not in "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("fact necessary for the result of death to occur when it did—nonetheless makes a difference to people’s intuition of blameworthiness. Trying to be a murderer and actually being one are simply different.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The notion of causation has strong intuitive roots with many people. To be the cause of a result, a person’s action must be necessary for that result. If the result would have occurred when it did even without the person’s action, then the action cannot be its cause. In this case, Luman’s death would have occurred when it did "), _c('em', [_vm._v("even if Wood had never shot Luman in the abdomen.")]), _vm._v(" Thus, Wood’s shot was not necessary for Luman’s death, and therefore it is not seen as the factual cause of Luman’s death. For this reason, Wood deserves less punishment.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec9"
    }
  }, [_c('strong', [_vm._v("The Law’s Rules")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The law tracks lay intuition on this issue. Criminal codes almost universally require that an actor’s conduct be necessary for a result to occur before it can be judged a “factual cause” of that result. (Codes also require for causation that the result be sufficiently proximate to the conduct—that it be “not too remote or accidental or too dependent upon another’s volitional act.”) The result of this legal causation inquiry will determine whether the person is liable only for attempt or for the full offense. In Wood’s case, this is the difference between attempted murder and murder. The difference is of great legal significance because attempt typically is graded at a lower level than the completed offense, and commonly is punished at half the penalty for the full offense.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec10"
    }
  }, [_c('strong', [_vm._v("The Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later in the day of the shooting, Wood and Alma are arrested and jailed. The preliminary examination takes place on November 10 in the city court. The hearing is long and exhaustive and at the conclusion of the arguments, the judge determines that Wood and Alma must remain in custody pending a hearing by the grand jury and, if indicted, trial on the charge of murder. At the September term of the Chittenden County Court, 1880, the grand jury finds a true indictment on several counts against the two. The daughter, Helen Smith, four, among others, testifies as to the events.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Left")]), _vm._v(" Burlington Police Department, which investigated the murder of Luman Smith. (Vermont Historical Society)")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Right")]), _vm._v(" Chittenden County Courthouse in Burlington, Vermont, where "), _c('em', [_vm._v("State v. Wood")]), _vm._v(" was tried. (Vermont Historical Society)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The trial is presided over by Judge Wheelock G. Veazey."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01.fn1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01fn1#ch01fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" The evidence at trial makes clear that “Luman died of the wound inflicted by Alma and not from that inflicted by Wood,” that “there was no concert of action between them, and each acted independently, and they were therefore only responsible for their own acts respectively,” and that “the wound inflicted by Wood was mortal and would in course of time have killed Luman, if he had not previously died from the wound inflicted by Alma.” But the judge instructs the jury that as a matter of law, this is enough to convict Wood of murder, even though Wood’s injury to Luman is not necessary for the death. The jury follows the instruction and convicts Wood of murder. Alma is also so convicted and both are sentenced to life in prison, as required by statute.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the case is appealed to the Vermont Supreme Court, where the court notes the erroneous jury instruction regarding causation—Wood "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("cannot be liable for murder if his shot was not necessary for Luman’s death—and reverses the conviction, remanding the case for a new trial.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec11"
    }
  }, [_c('strong', [_vm._v("Murder versus Attempted Murder:The Significance of Resulting Harm")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If Wood is convicted of only attempted murder, he is subject to a minimum term of five years, rather than the life imprisonment required upon conviction for murder. That dramatic difference in punishment reflects the strength of common intuition on the importance of resulting harm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That difference may seem irrational to some, but consider a world where resulting harm was ignored. There would be no offense of homicide or rape or robbery, only crimes of intentional conduct toward those ends. No offense would be defined to require actual result; all crimes would be defined simply as conduct that intended or risked the result. You drive home from a party and, as you pull into your garage, you realize what a risk you created to others by driving after drinking. In a world where resulting harm did not matter, your consciously creating a risk of death would be enough for liability equal to that for actually recklessly causing a death (manslaughter). You are no less liable because you were lucky enough on this occasion not to have killed anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Such a world simply does not match the community’s intuitions of justice. And a criminal law that took this view—that ignored whether or not a person actually caused the harm—would quickly lose credibility with the community. A criminal law without moral credibility can play no effective role in the public dynamic that shapes the society’s moral norms. In contrast, morally credible criminal law can help develop or reinforce norms against damaging conduct—such as domestic violence, drunk driving, child abuse, or insider trading—when it criminalizes the conduct or increases the seriousness of the offense’s grade or penalty. In addition, loss of moral credibility undercuts the powerful yet cheap deterrent effect that law can have by stigmatizing a violator. If criminal law has a poor reputation as a reliable authority in assessing blameworthiness, the imposition of criminal liability fails to carry a moral stigma.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But these useful powers of criminal law are possible only if the law has previously shown itself to be a reliable judge of what is truly "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("condemnable. To adopt rules of criminal liability that conflict dramatically with community intuitions, as in ignoring the strong community sense that causing harm matters—that a murder is really worse than an attempted murder—is to undercut criminal law’s moral credibility and reduce its power to stigmatize and to shape the development of community norms.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec12"
    }
  }, [_c('strong', [_vm._v("The Final Outcome")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On July 5, 1881, before Wood gets his retrial, he dies. At Alma’s re-trial, she initially pleads guilty to manslaughter. But after the indictment is read, she changes her mind and pleads not guilty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the conclusion of trial, the jury finds her not guilty, accepting her claim of self-defense.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec13"
    }
  }, [_c('strong', [_vm._v("The Requirements of Criminal Liability")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Together, the "), _c('em', [_vm._v("Phillips")]), _vm._v(" and "), _c('em', [_vm._v("Wood")]), _vm._v(" cases tell us something about the fundamentals of criminal liability, points on which law and common intuition generally agree. Criminal liability and punishment require, at minimum, a sufficiently developed and resolute intention and sufficiently advanced conduct toward an offense. In addition, once these minimum requirements of liability are established, the seriousness of an offense is increased if the offender actually brings about the harm or evil of the offense—whatever it be, bank robbery or death—and such an increase in seriousness translates into a higher statutory offense grade and greater punishment. While these may seem unexceptionable and commonsense lessons in the rules for assigning blame and punishment, the next case shows that the criminal law regularly violates these rules and challenges these lessons.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev1sec3"
    }
  }, [_c('strong', [_vm._v("LIFE IMPRISONMENT FOR AIR CONDITIONING FRAUD?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("William J. Rummel has had trouble holding down any kind of job. More because of laziness than inability, he has opted instead to make his living through small-time larceny and fraud. If he were good enough, check forgery might be called his specialty. But he is not and his arrests begin to pile up. As a con man, the tall and thin Rummel is inept, leaving "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("clues like his real name and signature on receipts from stolen credit cards and on stolen checks. His legitimate skills are as limited as his criminal ones. His educational background consists of a few Dale Carnegie courses. At the age of thirty, he has no family and no friends. His parents are both alive but their health is poor and they see Rummel rarely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On August 15, 1972, Rummel walks into Captain Hook’s Lounge in San Antonio. It is a hot day and the bar’s air conditioning is not working. Rummel gets an idea. He approaches the bar’s owner, David Shaw, and offers to fix the air conditioner. Shaw agrees and Rummel begins his inspection. After a few minutes and a little tinkering, Rummel announces the unit needs a new compressor. Cost: $129.75, labor free. Shaw quickly agrees and writes Rummel a check for the amount payable to Rummel. Rummel leaves, cashes the check, and never returns. Shaw files a complaint with the police, who easily trace Rummel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rummel’s offense, theft by false pretext, would normally render him liable under Texas law for a maximum sentence of between two and ten years, although violators typically are given a sentence of months, not years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Rummel has a criminal record. On October 20, 1959, in San Antonio he is convicted of misdemeanor theft and unlawful possession of alcoholic beverages. On the day of those convictions at the Bexar County Courthouse, he is arrested again, for unlawfully carrying a Bowie knife. He is convicted of the weapons charge on January 21, 1960, and fined one hundred dollars. On May 17, 1960, he is given three years of probation on a burglary charge. On July 25, 1963, he passes a ten dollar bad check at a Holiday Inn and on December 22, 1963, a thirty-dollar bad check. He is convicted on March 6, 1964, of two counts of swindling by check and is sentenced to thirty days in jail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On December 16, 1964, Rummel is convicted of credit card fraud after he uses a company credit card without authority to buy two new tires for his car, worth a total of $80. He is sentenced to three years in prison, but is paroled. He violates parole on July 21, 1966, and is returned to the Department of Corrections on August 25, 1966. On February 21, 1968, Rummel is convicted of aggravated assault on a female, Penny Rummel, and is sentenced to thirty days in jail. On the day of his assault conviction, he passes a bad check for $5.61 at a Gulf service station and is convicted of swindling by check. He is sentenced to thirty days, to run consecutively with the sentence for the assault conviction. On March 11, 1969, Rummel is convicted of forging a $28.36 check and is sentenced to two to four years in prison, of which he serves twenty-eight months.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0030-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("William James Rummel in 1980. (Corbis)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("What liability and punishment would you impose on Rummel for his $129.75 air conditioning fraud?"), _c('br'), _c('br')]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "85%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("no liability")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("liability but no punishment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 day")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 weeks")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("6 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 year")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("7 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("15 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("30 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("life imprisonment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("death")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/box1.jpg"
    }
  }), _c('br'), _c('br')])])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec14"
    }
  }, [_c('strong', [_vm._v("People’s Intuitions of Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While Rummel’s offense on this particular occasion is not terribly serious, most people are likely to feel that he deserves more than if this were his first offense. His repeated violations have the appearance of thumbing his nose at the law and at the community’s norms. The “more” he deserves for nose-thumbing may not be as much as what he deserves for the offense itself; the thumbing isn’t a greater violation than the offense itself, but rather an aggravating circumstance. But the nose-thumbing does suggest some percentage increase in what otherwise would be deserved.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Here is how the people in the survey sentenced Rummel:"), _c('br'), _c('br')]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "85%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("no liability")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("liability but no punishment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 day")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 weeks")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("6 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("9%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 year")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("18%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("29%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("7 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("30%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("15 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("7%")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("30 years")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("life imprisonment")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("death")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Mean = 2.8 years."), _c('br'), _c('br')])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("The average sentence imposed is less than three years, which is about what Rummel served for his last theft conviction. But 66 percent would impose a sentence of three years or more, which would be providing an increase over his last sentence.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec15"
    }
  }, [_c('strong', [_vm._v("Trial and Sentence")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On April 10, 1973, a jury convicts Rummel of the theft. Because the value is over fifty dollars, the offense is a felony. The next day, the state presents evidence of two prior felony convictions and asks the judge to declare Rummel a habitual criminal. A habitual criminal classification authorizes a dramatic increase in the available prison term, under the theory that such is the only effective way of preventing habitual offenders from committing more offenses in the future. The declared purpose of the Texas sentencing statute is to deal “with those who by repeated criminal acts have shown that they are simply incapable of conforming to the norms of society as established by its criminal law.” The prior felony offenses that qualify Rummel include the December 1964 credit card fraud and the March 1969 forgery. All totaled, the three felonies netted Rummel $233.11. Following the statute’s direction, on April 26, 1973, the judge sentences thirty-year-old Rummel to life in prison without parole.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec16"
    }
  }, [_c('strong', [_vm._v("Punishing Dangerousness: Cloaking Preventive Detention as Criminal Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There can be little doubt that crime is a problem in the United States. While crime rates have leveled off and even fallen some, they remain dramatically higher than they were forty years ago. Today’s murder rate is twice what it was in 1955. Rape rates have quadrupled, as have robbery rates. The aggravated assault rate has increased fivefold. Overall, including both rural and urban areas, the serious crime rate is four times what it was four decades ago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nor can there be doubt that repeat offenders are a serious part of the crime problem. One classic study of ten thousand young male offenders in Philadelphia revealed that 18 percent of the offenders committed five or more offenses, and that this group of “chronic offenders” committed 52 percent of all the group’s offenses. Another study found "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("that about 70 percent of violent crimes are committed by the same 6 percent repeat offenders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nor can one reasonably dispute that a society must be able to, and inevitably will, do what is necessary to protect itself from dangerous persons. Any democratic government that does not will soon lose political power.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But while the protection of society from dangerous persons is legitimate and inevitable, the use of the criminal justice system for that end, as in the Texas habitual offender statute, creates serious complications. A system that distributes liability and punishment in order to protect society from dangerous persons assigns liability and punishment differently than one that distributes liability and punishment to do justice. Not all dangerous people are blameworthy. Severely mentally ill persons and persons with contagious diseases, for example, may need detention but may not deserve punishment. Similarly, not all blameworthy persons are dangerous. The law-abiding citizen recently discovered to be a former Nazi concentration camp commandant deserves punishment even if he is no longer a danger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A just punishment system and a protection system are very different. The former focuses on what is deserved for a past wrong, while the latter has no reason to even require one. For example, there may exist a test that reliably predicts the persons who will commit certain kinds of sexual offenses in the future. Would it be justice to “punish” persons who fail the test? Obviously not. One can debate whether some preventive measures are appropriate, but there is no ground for punishment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is impossible to "), _c('em', [_vm._v("punish dangerousness")]), _vm._v(", of course, within the meanings of those terms. To “punish” is “to subject to pain, loss, confinement, death, etc., as a penalty for some offense or transgression”; that is, punishment focuses on "), _c('em', [_vm._v("a past")]), _vm._v(" crime or wrongdoing. “Dangerous” means “likely to cause injury, pain, etc.,” that is, a threat of "), _c('em', [_vm._v("future")]), _vm._v(" harm. One can “restrain” or “detain” or “incapacitate” to prevent a future crime, but one cannot logically “punish” dangerousness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The criminal justice system generally purports to be in the business of doing justice, giving offenders what they deserve, no more, no less. It calls itself the criminal "), _c('em', [_vm._v("justice")]), _vm._v(" system, not a "), _c('em', [_vm._v("preventive detention")]), _vm._v(" system. It describes its sanctions as "), _c('em', [_vm._v("punishment")]), _vm._v(", and on this ground justifies punitive conditions of confinement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("In cases like "), _c('em', [_vm._v("Rummel")]), _vm._v(", however, the system quietly shifts from a justice rationale to a protection rationale without openly admitting the change. The system keeps the “punishment” label, but uses it as a cloak for its preventionist purpose. It does not punish Rummel for what he has done; his current offense is minor (and he already has been punished for his previous offenses). Further, even taken together, his string of minor thefts and frauds would not add up to deserve life imprisonment, a punishment typically reserved for murder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In reality, Rummel is being punished for what he is thought likely to do in the future. The currently popular “three strikes” statutes assign punishment for the same reason. Indeed, the drafters of “three strikes” laws—of which the statute in "), _c('em', [_vm._v("Rummel")]), _vm._v(" was one of the first—typically are explicit about their protectionist goals and rationales. They keep the “justice” label because it makes the long-term incapacitation of offenders easier, simpler, and cheaper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A true punishment system logically can set a fixed term of imprisonment, giving no further thought to the propriety of release until the set release date arrives. The length of the imprisonment is a function of the punishment deserved for the past offense, and such deserved punishment does not change while the term is being served. In contrast, a prevention system—which justifies incarceration by a person’s dangerousness—logically must periodically reconsider whether the justification for detention continues to exist, and must release the detainee as soon as he is no longer dangerous. Further, a preventive detention system might conclude, upon evaluating a case like Rummel’s, that the danger of additional minor theft offenses cannot justify the deprivation of liberty—life imprisonment—that prevention would require. But such an issue is never considered under the present system because the system does not openly admit that it is in fact a system of preventive detention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The shift to a prevention rationale also affects the proper conditions of incarceration. Imprisonment justified as deserved punishment logically can have punitive conditions. The point of the imprisonment is to impose deserved suffering (but ought not dehumanize or demean). Preventive detention, in contrast, is an intrusion on liberty that an individual suffers for our benefit. We ought to, and commonly do, treat differently the person being punished and the person involuntarily confined because of a contagious disease or civilly committed because of mental disease. For the latter prevention cases, the conditions of confinement "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("logically should be nonpunitive. The person is already suffering a substantial loss of liberty for our benefit. We logically ought to minimize the extent of the intrusion as much as is consistent with public security. That may mean not only nonpunitive conditions, but also less intrusive forms of custody, such as house detention or electronic bracelet surveillance if such would provide adequate security.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Further, a prevention rather than punishment rationale logically suggests that if there is something that can be done to reduce or extinguish the detainee’s dangerousness, it ought to be done at the detainee’s request and at our expense. This means, for example, that a detainee ought to have an absolute right to any treatment that can reduce the need for or the extent of the loss of liberty being imposed on him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In other words, if the system is to shift from one of punishment to one of prevention—as it does in "), _c('em', [_vm._v("Rummel")]), _vm._v("—it logically must change the way it operates: provide periodic reviews, nonpunitive conditions, least intrusive restraint, and a right to treatment. The current criminal justice system typically does not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A more serious problem with prevention cases like "), _c('em', [_vm._v("Rummel")]), _vm._v(" becomes apparent when we consider it under the fundamental principles of justice we see expressed in cases like "), _c('em', [_vm._v("Phillips")]), _vm._v(" and "), _c('em', [_vm._v("Wood.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We are highly suspicious that Phillips is on his way to a robbery. But he has not yet gone far enough toward an offense for us to comfortably impose criminal liability and punishment. We can’t punish a person for what we think they might do, we said, even if the person’s intention is evident. Yet Rummel has done "), _c('em', [_vm._v("nothing")]), _vm._v(" toward the future offenses for which we now punish him. Indeed, he has not even thought of the offenses that are used as the justification for his incarceration.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One might try to argue that Rummel is different from Phillips because the former, Rummel, has prior offenses and therefore is an importantly different case. But the minimum requirements for attempt liability, as expressed in "), _c('em', [_vm._v("Phillips")]), _vm._v(", do not differ according to whether the person has a prior criminal record. (In fact, Phillips did have a prior record.) Phillips would have escaped attempt liability even if he had as many prior robbery convictions as Rummel had prior thefts. Similarly, Wood would have been convicted of only attempted murder, not murder, no matter what his prior record.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But perhaps one can argue that Rummel can be treated differently than Phillips because Rummel in fact committed an offense on this occasion; Phillips committed no robbery. Once one has done enough to "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("qualify for "), _c('em', [_vm._v("some")]), _vm._v(" criminal liability, it might be argued, the law is then free to do as it chooses in the amount of punishment it imposes. Innocent citizens need not fear unfair criminal liability; but for lawbreakers, all bets are off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But that harsh theory of criminal justice is inconsistent with what we saw in the "), _c('em', [_vm._v("Wood")]), _vm._v(" case. There, the law with strong public support took great pains to determine the proper grade that Wood’s offense deserved. The only issue in "), _c('em', [_vm._v("Wood")]), _vm._v(" is whether he should be liable for attempted murder or murder. The facts in "), _c('em', [_vm._v("Wood")]), _vm._v(" present the most egregious case possible—of a person who has done everything he can do to be a murderer—yet the community and the law refuse to treat him as a murderer because his conduct does not meet the strict requirements of causation. He can be held liable only for the lower grade offense of attempt. Yet Rummel is being punished as if he had actually caused the harms of all those future offenses, offenses of which he has not yet even thought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The law’s inconsistency in this regard also is apparent in other ways. For example, the law explicitly limits the use of a defendant’s prior criminal record at trial, for fear that it may prejudice the jury. We say that the defendant’s liability ought to be determined solely according to the prosecution’s proof of what he did on this occasion. But the prejudicial fact of prior record somehow becomes a respectable principle when the amount of punishment is being set. We say the prosecution cannot introduce a prior offense to suggest the defendant was more likely to have committed the present offense. But isn’t this just what “three strikes” laws do, and worse: they use prior offenses to suggest the defendant is likely to commit a future offense, and justify life imprisonment on these predicted future offenses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prior record, as a predictor of future criminality, is one of the primary determinants of sentence in a preventionist system. If prevention is a legitimate ground for distributing liability and punishment, why not openly declare prior record relevant in assessing liability? Why not include prior record as an element of offenses and as a determinant of offense grade? Under the preventionist rationale, logically, in close cases, we should convict a Phillips of attempt if he has a prior record, and convict a Wood of murder if he has a prior criminal record. Yet no jurisdiction does this. Jurisdictions do not do so because no one is seriously prepared to openly offer prevention as a substitute for justice. Instead, "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("prevention is cloaked as desert, and hides in the shadows of a system that purports to do justice.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec17"
    }
  }, [_c('strong', [_vm._v("The Appeal")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rummel appeals his case to the U.S. Court of Appeals for the Fifth Circuit, located in New Orleans. Helping to craft his own motions and arguments from the prison library, he contends that the state’s one-hundred-year-old habitual offender law violates the Eighth Amendment prohibition against cruel and unusual punishment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On March 6, 1978, a three-judge panel of the Fifth Circuit reverses his sentence as cruel and unusual. However, on December 20, 1978, the Fifth Circuit sitting as a whole for a rehearing—lawyers call it sitting "), _c('em', [_vm._v("en banc")]), _vm._v("—reinstates the sentence by an eight to five vote and upholds the constitutionality of the Texas habitual offender statute. Rummel appeals to the U.S. Supreme Court, pushing his claim that the disproportionate length of his sentence compared to the seriousness of his crimes violates the Eight Amendment prohibition against cruel and unusual punishment. He also claims his attorney was incompetent. The high court agrees to hear his case, to be argued "), _c('em', [_vm._v("pro bono")]), _vm._v(" by Scott J. Atlas, a partner in the prominent Houston law firm of former Texas governor John B. Connally. “No jurisdiction in the United States or the free world punishes habitual offenders as harshly as Texas,” Atlas writes in his brief.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec18"
    }
  }, [_c('strong', [_vm._v("The Cost of Undercutting the Criminal Law’s Moral Credibility")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rummel’s punishment is unfair, it was suggested earlier, because it imposes punishment far out of proportion to what he deserves for his offense. And it is unfair because, as a form of preventive detention, it fails to limit the detention to a period of continuing dangerousness, it fails to weigh the extent of the danger threatened against the loss of liberty required to prevent it, and it fails to limit the confinement to non-punitive conditions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But perhaps more important than seeing the injustice to Rummel is to see how the injustice to Rummel is damaging to us. As noted in the discussion of the "), _c('em', [_vm._v("Wood")]), _vm._v(" case, the moral credibility of the criminal law is central to its ability to stigmatize and thereby deter conduct. Even more important, it is the source of the criminal law’s power to influence the "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("norms that govern people’s conduct. Recent social science research has only confirmed what many have long sensed: societal norms internalized by an individual and by the individual’s circle of family and friends influence the person’s conduct more than the threat of official sanction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fact is, the perceived chances of getting caught and convicted for an offense are so low that few people obey the law out of fear of official punishment. An astounding number of serious offenses are never reported to the police—for example, 21 percent of rapes and 40 percent of burglaries—out of embarrassment, out of fear of reprisal, or in the belief that the authorities are unable or unwilling to act. For the offenses reported, clearance rates (the rates at which the police identify and arrest suspects) have been dropping steadily for decades. The nationwide clearance rate for homicide, which was 93 percent in 1955, has steadily declined to 67 percent. The rate for rape has declined from 79 to 52 percent and that for burglary from 32 to 14 percent. Further, being arrested is a far cry from being punished. The overall conviction rate among those arrested for the most serious offenses is 30 percent. Then, fewer than half of those convicted of a felony are sentenced to state prison. Finally, the median time served by those actually sentenced to a state prison ranges from 5.5 years for murder to 2.2 years for kidnapping to 1.4 years for arson.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cumulative effect of the many escape hatches from punishment leaves a deterrent threat that looks like this: homicide offers less than a 45 percent chance of being caught, convicted, and imprisoned, rape a 12 percent chance, robbery a 4 percent chance. Assault, burglary, larceny, and motor vehicle theft are each a hundred-to-one shot. A potential offender may not be cowed by these threats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The threat of punishment may play some role with some people, but the force of norms in influencing conduct plays a substantial role with nearly all people. The real power to enforce compliance with society’s rules of prescribed conduct lies not in the threat of official criminal sanction, but in the influence of family and peers in judging each of us and our own internalized norms by which we judge ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The law is not irrelevant to these social and personal forces. Criminal law, in particular, plays a central role in creating and maintaining the social consensus necessary for sustaining moral norms. In fact, in a "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("society as diverse as ours, the criminal law may be the only society-wide mechanism that transcends cultural and ethnic differences. Thus, the criminal law’s most important real-world effect is arguably its ability to assist in the building, shaping, and maintaining of these norms. It contributes to and harnesses the compliance-producing power of interpersonal relationships and personal morality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition, if the criminal law earns a reputation as a reliable statement of what the community, given sufficient information and time to reflect, perceives as condemnable, people are more likely to defer to its commands as morally authoritative in those borderline cases where the propriety of certain conduct is unsettled or ambiguous in the mind of the actor. The importance of this role should not be underestimated; in a society with the complex interdependencies characteristic of ours, an apparently harmless action can have destructive consequences. When the action is criminalized by the legal system, one wants the citizen to “respect the law” even though he or she does not immediately intuit why that action is banned. Such deference is facilitated if people believe the law is an accurate guide to what is truly immoral behavior.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here, then, are at least two ways the criminal law can influence conduct: by discouraging conduct that it identifies as criminal and thus immoral and, less directly but more powerfully, by helping to shape community norms that condemn some conduct and not others. The criminal law’s effectiveness in both these respects is to a great extent dependent on the degree of moral credibility it has achieved. With strong moral credibility, criminalization persuasively signals immoral conduct. With weak credibility, it can have little effect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thus, the criminal law’s moral credibility is essential in the long run to effective crime control. Credibility is enhanced if the distribution of criminal liability is perceived as “doing justice,” that is, if liability and punishment are assigned in ways that the community perceives as consistent with its principles of justice. Conversely, the system’s moral credibility, and therefore its crime control effectiveness, is undermined by a distribution of liability that deviates from community perceptions of just desert. What effect can one expect from newspaper headlines like those generated by the "), _c('em', [_vm._v("Rummel")]), _vm._v(" case: “Billy Sol [Estes] Bilks Companies Out of Millions; Rummel’s Fraud Totals $229.11. Estes Serving 10 Years—Rummel Gets Life.”")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec19"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('strong', [_vm._v("The Final Outcome")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rummel, who has grown pale and thinner in prison, makes something of his time. In just over seven years he earns 67 hours of college credit, spends 350 hours teaching other inmates, and takes additional training in construction maintenance. His prison time passes unremarkably. Rummel is a “middle of the road type inmate,” prison warden D. A. Christian says. “He don’t cause any problems. He’s not a ring-leader or a big follower. In a prison, you know your troublemakers, your snitches. He’s not any of these. He’s not that violent. As a con man, he ranks low on the totem pole.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not saying I should not be punished, but why give me a life sentence?” Rummel asks an interviewer as he awaits his appeal. “If I had murdered 75 people or raped five women, something of that nature, I could see where I could become a potential threat to society. But who do I threaten? I don’t threaten anybody. I don’t use narcotics. I don’t use alcohol to any extent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1980, as the Supreme Court considers his appeal, Rummel’s case begins attracting national attention from newspapers and television stations. The television news magazine "), _c('em', [_vm._v("60 Minutes")]), _vm._v(" airs a segment on his case in the winter of 1980. The local prosecutor’s office begins to bristle under the spotlight, angered that the media portray Rummel as a mere petty thief and ignore his long history of offenses. Finally, on March 19, the Supreme Court issues its ruling and rejects Rummel’s claim that his life sentence is unconstitutionally cruel and unusual because it is disproportionate to the seriousness of his offense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Rummel’s case and the attention it generates do not go away. Less than two months after the Supreme Court upholds Rummel’s sentence, U.S. District Judge D. W. Suttle orders the state to release Rummel or give him a new trial. Suttle rules that Rummel’s trial attorney, William B. Chenault III, provided ineffective counsel in 1973 when Rummel received the life sentence. Noting that Chenault attempted virtually no investigation of the case before it went to trial, Judge Suttle orders Rummel released and sent back to criminal court for a new trial. The district attorney, still weary from the nationwide publicity aimed at Rummel’s case, offers Rummel a deal: if Rummel pleads guilty to felony theft over fifty dollars, the state will recommend an eight-year prison sentence. That would allow Rummel, who has already served almost eight years, to go free immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("Even if he were retried, the theft charge he was convicted of in 1973 has been reduced by the Texas legislature to a misdemeanor, meaning the habitual offender statute no longer would require a life term and he could not be sentenced to more time than he already has served. On November 15, surrounded in court by national news media, Rummel pleads guilty to the theft offense and receives a seven-year sentence backdated to 1973. He is released from custody five hours later. “I am ready to go out and work. And I intend to stay free for the rest of my life.” As of this writing, he apparently has.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01lev2sec20"
    }
  }, [_c('strong', [_vm._v("Segregating Preventive Detention from Criminal Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The problems raised by cases like "), _c('em', [_vm._v("Rummel")]), _vm._v(" are not easily solved. Rummel’s sentence seems dramatically more than he deserves, wildly disproportionate to the seriousness of his offense. On the other hand, a society must be able to protect itself. The criminal justice system, which deals with harmdoers, is an obvious and convenient mechanism to use to protect us from harm. But using criminal justice for prevention means that it sometimes does not do justice. And not doing justice undercuts the system’s moral credibility and, thereby, its long-term crime-control effectiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What is needed, perhaps, are two mechanisms: one to punish offenders for past crimes with a criminal sentence for a fixed term according to the amount deserved for the past offense, no more, no less; and another mechanism, apart from the criminal justice system, to civilly commit offenders who are shown to remain dangerous at the conclusion of their criminal sentence. That could protect the moral credibility of the criminal justice system from the taint of undeserved punishment, while insuring preventive detention. Even more important, such a preventive detention system, which openly admits its purpose and rationale, logically would give detainees the periodic review, minimum restraint, right to treatment, and nonpunitive conditions that our current scheme of criminal commitment denies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Such a two-system scheme also would be a more honest approach, admitting openly when incarceration is preventive detention rather than deserved punishment. Without the obfuscation of our current mixed punishment-prevention system, preventive detention would have to justify itself. The public might conclude that the threat that a Rummel presents cannot justify the imposed detention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("Many states have implemented such a distinct civil detention system on a small scale, for application against sexual predators who remain dangerous at the conclusion of their prison terms."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01.fn2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01fn2#ch01fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" Ironically, this effort has met a host of challenges by the ACLU and similar groups. These much-criticized “sexual predator” laws provide for the civil commitment of sexual offenders if, at the conclusion of their criminal sentence, they remain likely to repeat their sexual offenses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Such a two-system approach permits minimum use of dangerousness considerations in criminal sentencing decisions. It relies instead on the explicit preventive-detention civil commitment process to provide any additional protection needed beyond that inherent in the criminal term. (In this respect, legislators might improve some of these statutes by making it clearer that the initial criminal sentence must be based solely on the defendant’s desert, without reliance on predictions of his future dangerousness.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If restricting civil liberties is the concern, the civil commitment approach seems preferable to that of the many states that sentence such sex offenders to life imprisonment as a preventive measure. Oddly enough, the latter scheme—life imprisonment for sexual offenders—is the safer course for states, given the current constitutional restrictions on civil commitment, which require periodic review of both continuing mental illness and dangerousness. The periodic review requirement is not applied to criminal commitment, presumably because criminal commitment is justified as punishment for a past offense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But this simply illustrates the deceptiveness of our present system. By considering dangerousness in setting "), _c('em', [_vm._v("criminal")]), _vm._v(" terms, the state avoids the periodic review requirement that appropriately ought to attach whenever dangerousness is the justification for commitment. But because the commitment is labeled “criminal,” and thus apparently based on blameworthiness for a "), _c('em', [_vm._v("past")]), _vm._v(" offense, no periodic review is thought to be required. Logic would seem to suggest that if the criminal law is not purged of its reliance on dangerousness in setting incarceration terms, the standard civil commitment requirements, including periodic review, "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("ought to be applied to that additional portion of the term imposed on dangerousness grounds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even from an offender’s point of view, opposing such civil commitment schemes seems a bit mad. If the state has the ability to provide a long prison term for the offense, such as life imprisonment, why oppose a provision that can allow the state to give a shorter term, so that only those offenders shown to be dangerous are detained longer, and then only as long as they remain dangerous? This is especially true given that the terms and conditions of such civil commitment may be better than those for a criminal life term: periodic reviews of the justification for detention, a logical claim for least restricting confinement, nonpunitive conditions, and a right to treatment (all conditions that are difficult to claim in the context of criminal commitment, where the imprisonment is supposedly deserved as punishment for a past offense).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We can rebuild the moral credibility of the criminal law by putting it back into the business of doing justice, undistorted by other functions. If protection is needed, let it be done: first, only when present dangerousness is shown; second, only in a way that minimizes the loss of individual liberties; and third, in a form that does not confuse such preventive detention with deserved punishment and, therefore, does not taint the criminal justice system’s claim to be doing justice.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 78
// module chunks = 0